import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="px-6 lg:px-10 pt-14 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10 lg:gap-8 pb-10 border-b border-secondary-800">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-play-fill text-[20px]"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-bold text-[18px] text-background-50">
                  蘑菇视频
                </span>
                <span className="font-label text-[10px] tracking-[0.2em] uppercase text-secondary-300 mt-0.5">
                  Mushroom Video
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-secondary-200 max-w-sm">
              一个把热门视频、短视频合集与专题索引整理到一处的浏览入口。用最少的时间，先找到想看的，再决定看多久。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["更新条", "专题索引", "资源速查"].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full bg-secondary-900 text-secondary-200 text-xs"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-label text-xs tracking-[0.18em] uppercase text-accent-400">
                <a href="#top" className="cursor-pointer hover:text-accent-300 transition-colors">
                  {col.title}
                </a>
              </h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-sm text-secondary-200 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-300">
            © 2026 蘑菇视频 · 本站为内容索引与展示示例，仅作浏览参考
          </p>
          <div className="flex items-center gap-5 text-xs text-secondary-300">
            <span className="flex items-center gap-1.5">
              <i className="ri-database-2-line"></i>
              资源均已整理归档
            </span>
            <a href="#faq" className="hover:text-background-50 transition-colors cursor-pointer">
              常见问答
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}